/*
 * Copyright © 2021 Aram Meem Company Limited.  All Rights Reserved.
 */

import Marker from "react-google-maps/lib/components/Marker";
import withGoogleMap from 'react-google-maps/lib/withGoogleMap';
import { GoogleMap } from 'react-google-maps';
import withScriptjs from 'react-google-maps/lib/withScriptjs';
import * as React from 'react';
import SearchBox from 'react-google-maps/lib/components/places/SearchBox';
import i18n from '../getText';

declare const google: any;

export const MapWithMarker = withScriptjs(withGoogleMap((props: {
  currentLocation,
  dropOffLocation,
  onSearchBoxMounted,
  onMapMounted,
  bounds,
  onCenterChanged,
  onPlacesChanged
}) => {
  let current = null;
  if (props.currentLocation && props.currentLocation.lat) {
    current = {lat: props.currentLocation.lat, lng: props.currentLocation.lon};
  }

  let dropOff = null;
  if (props.dropOffLocation && props.dropOffLocation.lat) {
    dropOff = {lat: props.dropOffLocation.lat, lng: props.dropOffLocation.lon};
  }

  const updateMapBounds = (map: GoogleMap) => {


    // TODO. It's a hack. I don't know how to fix it
    if (!map) {
      return;
    }
    props.onMapMounted(map);
    const bounds = new google.maps.LatLngBounds();

    if (dropOff) {
      bounds.extend(dropOff);
    }

    // Don't zoom in too far on only one marker
    if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
      const extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.001, bounds.getNorthEast().lng() + 0.001);
      const extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 0.001, bounds.getNorthEast().lng() - 0.001);
      bounds.extend(extendPoint1);
      bounds.extend(extendPoint2);
    }

    map.fitBounds(bounds);
    map.panToBounds(bounds);
  };

  return (
    <GoogleMap
      defaultOptions={{disableDefaultUI: true, gestureHandling: 'greedy'}}
      defaultZoom={14}
      onCenterChanged={props.onCenterChanged}
      ref={(ref) => updateMapBounds(ref)}
    >
      <SearchBox
        ref={props.onSearchBoxMounted}
        bounds={props.bounds}
        controlPosition={google.maps.ControlPosition.TOP_LEFT}
        onPlacesChanged={props.onPlacesChanged}
      >

        <div className="map-search search_block">
          <button type="button" className="search_block-btn">
            <img src="assets/icSearch.png"
                 srcSet="assets/icSearch@2x.png 2x, assets/icSearch@3x.png 3x"
                 alt=""/>
          </button>

          <input
            type="text"
            placeholder={i18n.pgettext('SelectAddressMap', 'Find the address')}
            className="search_block-input"
          />

        </div>
      </SearchBox>
      <Marker
        position={current}
        animation={google.maps.Animation.DROP}
        icon={{
          url: 'assets/current-location.svg',
          anchor: new google.maps.Point(24, 28),
        }}
      />
      <img style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        height: '66px',
        width: '38px',
        marginLeft: '-19px',
        marginTop: '-66px'
      }} src="assets/person.png" srcSet="assets/person@2x.png 2x, assets/person@3x.png 3x" alt=""/>

    </GoogleMap>
  )
}));



// WEBPACK FOOTER //
// ./src/app/components/MapWithMarker.tsx